export default __webpack_public_path__ + "static/media/sixteen.5bf18d34.png";